import React, {Component} from 'react';
import ProSignUpForms from '../parts/ProSignUpForms';
import logoBlack from '../assets/images/logo-black.png';
import config from "../config";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaTitles, title} from "../website-utils/meta";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";


class ProSignUpPage extends Component {
  componentDidMount() {
    window.analytics.page("Pros", "Sign Up");
  }

  render() {
    window.prerenderReady = true;

    return (
      <div className="pros registration">
        <Helmet>
          {title('SingleShift - Pros Sign Up')}
          {metaTitles('SingleShift - Pros Sign Up')}
          {metaDescriptions('Earn money picking up shifts at restaurants and events, right from your phone.')}
        </Helmet>
        <ScrollToTopOnMount/>

        <div className="container">

          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <Link to={config.routes.pros}>
                <img className="logo" src={logoBlack}/>
              </Link>
            </div>
          </div>

          {/* Error Messages */}
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <div className="alert alert-danger" role="alert" style={{display: 'none'}}>
                <ul></ul>
              </div>
            </div>
          </div>

          {/* Registration Form */}
          <div className="singleshift-form">
            <ProSignUpForms/>
          </div>

        </div>
      </div>
    );
  }
}


export default ProSignUpPage;



// WEBPACK FOOTER //
// ./src/pages/ProSignUpPage.js